import { apiClient } from "../clientApi";
import { useMutation } from "@tanstack/react-query";
import type { DefaultError } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";
import Cookies from "js-cookie";

type LoginData = {
  email: string;
  password: string;
  login_type?: string;
};

type AuthTokensResponse = {
  access: string;
  refresh: string;
  user: {
    id: number | string;
    email: string;
    firstName: string;
    lastName: string;
    role: "user" | "org_admin" | "super_admin";
    org_id: number;
    org_name: string;
  };
};

type Refresh = {
  refresh: string;
};

export const useLoginMutation = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: (data: AuthTokensResponse, variables: LoginData, context: any) => void;
  onFail?: (error: any, variables: LoginData, context: any) => void;
}) =>
  useMutation<AuthTokensResponse, DefaultError, LoginData>({
    mutationFn: async (form) => {
      const { data } = await apiClient.post<AuthTokensResponse, AxiosResponse<AuthTokensResponse>, LoginData>(
        `/auth/login?login_type=${form?.login_type}`,
        form
      );

      return data as AuthTokensResponse;
    },
    onSuccess,
    onError: onFail,
  });

export const useRefreshToken = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: any, variables: Refresh, context: any) => void;
  onError?: (error: any, variables: Refresh, context: any) => void;
}) =>
  useMutation<any, DefaultError, any>({
    mutationFn: async (form) => {
      const refreshToken = Cookies.get("refresh");

      const { data } = await apiClient.post<AuthTokensResponse, AxiosResponse<AuthTokensResponse>, Refresh>(
        "/auth/refresh/",
        { refresh: refreshToken! }
      );

      Cookies.set("access", data.access, { expires: 1 });
      Cookies.set("refresh", data.refresh, { expires: 30 });

      return data;
    },
    onSuccess,
    onError,
  });
